import fetch from "../../auth/FetchInterceptor";

export const getAccountSubscriptions = function () {
  return fetch({
    url: '/account_subscriptions',
    method: 'get',
  })
}

export const getAccountSubscription = (subscriptionId) => {
  return fetch({
    url: `/account_subscriptions/${subscriptionId}`,
    method: 'GET',
  });
}

export const createAccountSubscription = (data) => {
  return fetch({
    url: `/account_subscriptions`,
    method: 'POST',
    data,
  });
}

export const updateAccountSubscription = (subscriptionId, data) => {
  return fetch({
    url: `/account_subscriptions/${subscriptionId}`,
    method: 'PUT',
    data,
  });
}

export const deleteAccountSubscription = (subscriptionId) => {
  return fetch({
    url: `/account_subscriptions/${subscriptionId}`,
    method: 'DELETE',
  });
}

export const cancelAccountSubscription = (subscriptionId, reason) => {
  return fetch({
    url: `/account_subscriptions/${subscriptionId}/cancel`,
    method: 'POST',
    data: {
      cancel_reason: reason,
    },
  });
}

export const reactivateAccountSubscription = (subscriptionId) => {
  return fetch({
    url: `/account_subscriptions/${subscriptionId}/reactivate`,
    method: 'POST',
  });
}